import {Routes} from "@angular/router";

/**
 * This class methods have to remain empty. It's a placeholder for the
 * actual methods. These are located in src/debug.ts. This file is replaced
 * during the build. See base-angular.json, "fileReplacements".
 */
export class Debug {
  public static disableGuardsInRoutesIfWanted(routes: Routes): Routes {
    return routes;
  }
  public static mapDebugMethods(keysMethods: { code: string; method: Function; name?: string }[]): void {}
}

export function DebugKey(params: { code: string; name?: string }): Function | null {
  return null;
}
